import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';

import { Store } from '@ngrx/store';

import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipMarketSubTypeLogoService } from '../../../../picks/services/betslip-market-sub-type-logo.service';
import { BetBuilderSelectionModel } from '../../../../single-bet/components/betbuilder-selection.model';
import { selectPickErrorsForTypeFactory } from '../../../../validation/selectors';
import { BetBuilderPick } from '../../../models';
import { getBetBuilderSelections } from '../../../services/bet-builder.utils';

@Component({
    selector: 'bs-linear-bet-builder-selections-list',
    templateUrl: './linear-bet-builder-selections-list.component.html',
    styleUrls: ['./linear-bet-builder-selections-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderSelectionsListComponent {
    readonly pick = input.required<BetBuilderPick>();
    readonly selections: Signal<BetBuilderSelectionModel[]>;
    readonly inlineDetails = input<boolean | undefined>();

    constructor(
        store: Store,
        private betslipMarketSubTypeLogoService: BetslipMarketSubTypeLogoService,
    ) {
        const betBuilderPickErrors = store.selectSignal(selectPickErrorsForTypeFactory(BetslipType.BetBuilder));

        this.selections = computed(() => getBetBuilderSelections(this.pick(), betBuilderPickErrors(), this.betslipMarketSubTypeLogoService));
    }
}
